import { LABEL_QUEST, LABEL_QUEST_IMG } from "../constants.js";
import { createImagePicker } from "../imagePicker.js";

export function structureSingle(id, quantity = 6) {
  const answers = Array.from({ length: quantity }, (_, i) => i + 1)
    .map(
      (i) => `
        <div class="row">
            <div class="form-group">
                <label class="col-12">${i}. Antwort</label>
                <div class="col-12">
                    <input type="text" class="form-control form-control-sm" df-answer${i}>
                </div>
            </div>
        </div>`,
    )
    .join("");

  return `
        <div>
            <div class="title-box">
                <div class="title-text"><i class="bi bi-check2"></i> Frage mit Einfachauswahl</div>
                <button type="button" class="btn-node-delete" title="Element entfernen" aria-label="Element entfernen"><i class="bi bi-x-lg"></i></button>
            </div>
            <hr>
            <div class="content-box">
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">${LABEL_QUEST}</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-frage>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">${LABEL_QUEST_IMG}</label>
                        <div class="col-12">
                            ${createImagePicker(id, "frageimg", "df-frageimg")}
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-sm btn-primary"
                    data-bs-toggle="collapse" data-bs-target="#node${id}-answers">Antworten</button>
                <div id="node${id}-answers" class="answers collapse">
                    ${answers}
                </div>
            </div>
        </div>`;
}
